var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.96883 5.25745L9.12321 8.99401C9.10643 9.07219 9.06293 9.14208 9.00019 9.19164C8.93745 9.24121 8.85939 9.26735 8.77946 9.26557H2.19321C2.11327 9.26735 2.03521 9.24121 1.97247 9.19164C1.90973 9.14208 1.86623 9.07219 1.84946 8.99401L1.03133 5.25745C1.01756 5.19431 1.02187 5.12857 1.04376 5.06777C1.06565 5.00697 1.10423 4.95357 1.15508 4.9137C1.20607 4.87368 1.26734 4.8489 1.33181 4.84221C1.39628 4.83552 1.46133 4.84719 1.51946 4.87588L3.52696 5.8487L5.19071 2.9062C5.22069 2.85329 5.26416 2.80929 5.3167 2.77868C5.36924 2.74806 5.42896 2.73193 5.48977 2.73193C5.55058 2.73193 5.6103 2.74806 5.66283 2.77868C5.71537 2.80929 5.75885 2.85329 5.78883 2.9062L7.45258 5.85213L9.47383 4.87245C9.53237 4.84142 9.59863 4.82796 9.66463 4.83371C9.73064 4.83945 9.79357 4.86415 9.84587 4.90482C9.89817 4.9455 9.9376 5.00042 9.95941 5.06298C9.98123 5.12554 9.9845 5.19307 9.96883 5.25745Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVip);
export default __webpack_public_path__ + "static/media/icon-vip.14a5187bdb8dd1133bc0c6abf4b03eef.svg";
export { ForwardRef as ReactComponent };